import { defineComponent as _defineComponent } from 'vue'
import { DeletedItemStyleClass } from '@/@types/enums/ConfirmationDeleteItem/DeletedItemStyleClass';
import { DeletedItemType } from '@/@types/enums/ConfirmationDeleteItem/DeletedItemType';
import router from '@/router';
import { ARTICLE_CREATE, DRAFTS } from '@/routerNames';
import apiService from '@/services/ApiService';

import articleModeService from '@/services/article/ArticleModeService';
import confirmationService from '@/services/ConfirmationService';
import draftService from '@/services/draft/DraftService';
import urlService from '@/services/UrlService';
import store from '@/store';
import { dispatchGetRetentionCount } from '@/store/dispatchers/uiDispatchers';

import { computed } from 'vue';

import { Article } from '@/models/article/Article';
import { Workspace } from '@/models/Workspace';
import articleEditService from '@/services/article/ArticleEditService';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscardDraftMenuButton',
  setup(__props) {

const routes = useRoute();

const currentRouteName = computed((): string => routes.name);
const article = computed((): Article => articleEditService.articleEditor.article);
const workspace = computed((): Workspace => articleEditService.articleEditor.workspace);

const showDiscardDraftConfirmationPopup = (title: string) => {
  return confirmationService.showDiscardDraftPopup(title, DeletedItemType.DRAFT, DeletedItemStyleClass.DRAFT);
};

const handleDiscardChanges = async () => {
  await showDiscardDraftConfirmationPopup(article.value.title);

  const confirmation = false;

  // Delete draft if it's article creation page
  if (currentRouteName.value === ARTICLE_CREATE) {
    await draftService.deleteDraft(article.value, { confirmation });
  } else {
    await apiService.draft.discard(article.value.id);

    if (store.state.company.retention.enabled) {
      await dispatchGetRetentionCount();
    }
  }

  // redirection
  if (!article.value.original) {
    await router.push({ name: DRAFTS });
  } else {
    const mode = articleModeService.getArticleMode(article.value);
    await router.push(urlService.getArticleViewRoute(article.value, workspace.value, mode));
  }
};

return { __sfc: true,routes, currentRouteName, article, workspace, showDiscardDraftConfirmationPopup, handleDiscardChanges }
}

})